import EditStoreCategoriesDialog from './EditStoreCategoriesDialog';

export * from './EditStoreCategoriesDialogProps';
export default EditStoreCategoriesDialog;
